import { gql } from '@apollo/client';
export const APPLIED_RULE_FIELDS = gql `
  fragment AppliedRuleFields on AppliedRule {
    id
    clientId
    ruleType
    ruleSnapshotId
    ruleSnapshot {
      id
      ruleId
      createdAt
      updatedAt
      clientId
      ruleType
      policy
      criteria
      sortOrder
      isActive
      startsOn
      expiresOn
      target
      isException
    }
    isException
    paymentRequestId
    programId
    createdAt
    updatedAt
  }
`;
export const APPLIED_RULES = gql `
  ${APPLIED_RULE_FIELDS}
  query APPLIED_RULES($spec: AppliedRuleSpec!) {
    appliedRules(spec: $spec) {
      ...AppliedRuleFields
    }
  }
`;
export const SAVE_APPLIED_RULE = gql `
  ${APPLIED_RULE_FIELDS}
  mutation SAVE_APPLIED_RULE($input: AppliedRuleInput!) {
    saveAppliedRule(input: $input) {
      ...AppliedRuleFields
    }
  }
`;
export const DELETE_APPLIED_RULE = gql `
  ${APPLIED_RULE_FIELDS}
  mutation DELETE_APPLIED_RULE($id: Int!) {
    deleteAppliedRule(id: $id) {
      ...AppliedRuleFields
    }
  }
`;
